import {FormProvider, useForm} from "react-hook-form";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {SliderField} from "@/components/form/fields/SliderField/SliderField.tsx";
import {ANALYZER_DEFAULT_LOCATIONS_CAP} from "@/pages/analyzer/Analyzer.constants.ts";
import {AnalyzerSetLocationsFormProps, AnalyzerSetLocationsFormValues} from "@/pages/analyzer/Analyzer.types.ts";

export const AnalyzerSetLocationsForm = ({
  formId,
  onSubmit,
  defaultNumLocations,
  maxNumLocations,
}: AnalyzerSetLocationsFormProps) => {
  const {user} = useCurrentUserContext();
  const locationsCap = user?.account.limit_monitoring_groups || ANALYZER_DEFAULT_LOCATIONS_CAP;
  const max = Math.min(locationsCap, maxNumLocations ?? locationsCap);
  const defaultValue = Math.min(defaultNumLocations, max);

  const methods = useForm<AnalyzerSetLocationsFormValues>({
    defaultValues: {num_locations: defaultValue},
  });

  return (
    <FormProvider {...methods}>
      <form id={formId} onSubmit={methods.handleSubmit(onSubmit)}>
        <div className="mb-4">
          Note: Locations on the selected Checks will be replaced with whatever you select below. Checks that support
          fewer Locations keep their maximum, and Sensitivity is reduced where it would exceed the new Location count.
        </div>
        <SliderField name="num_locations" label="Locations per Check" defaultValue={defaultValue} min={1} max={max} />
      </form>
    </FormProvider>
  );
};
